import React, { useState } from 'react';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { Table } from 'antd';
import './PropertyAbout.scss';
import { useSelector } from 'react-redux';
import { aboutData } from '../../pages/PropertyListing/IOMultiData';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PropertyAbout = () => {
  const isSM = useMediaQuery('(min-width: 640px)');
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const { unitMixCols } = aboutData(screenMD);
  const [isExpanded, setIsExpanded] = useState(false);
  const { unitMix } = useSelector((state) => state.propertyDetails);
  const { data } = useSelector((state) => state.propertyDetails);

  // const unitMixData = useMemo(() => {
  //   return Object.keys(data?.data?.unitMix?.unitMix || {}).map((key) => {
  //     let obj = {
  //       type: key,
  //       count: data?.data?.unitMix?.unitMix[key].unit || '',
  //       avgSqFt: data?.data?.unitMix?.unitMix[key]?.sqft || '',
  //       percentage: data?.data?.unitMix?.unitMix[key]?.['%'] || '',
  //     };
  //     if (!key.toLowerCase().includes('studio')) {
  //       obj.type = key + ' bed';
  //     }
  //     return obj;
  //   });
  // }, [data?.data?.unitMix]);

  return (
    <div className='pt-48 pb-64 property-about'>
      <p className='mb-32 fz-24 fw-700 lh-13'>About this property</p>
      <p className='mb-40'>{data?.data?.propertyDesc}</p>
      <p className='fz-18 mb-16 fw-600'>Amenities</p>
      {isSM ? (
        <div className='amenities'>
          {data?.data?.amenities?.length
            ? data?.data?.amenities?.map((e, index) => {
                return (
                  <div className='amenities__item' key={index}>
                    <LazyLoadImage alt={e.name} src={e.image} />
                    <span className='amenities__item__label'>{e.name}</span>
                  </div>
                );
              })
            : 'No Amenities added'}
        </div>
      ) : (
        <div className={isExpanded ? 'amenities expanded' : 'amenities hidden'}>
          {data?.data?.amenities?.length
            ? data?.data?.amenities?.map((e, index) => {
                return (
                  <div className='amenities__item' key={index}>
                    <LazyLoadImage alt={e.name} src={e.image} />
                    <span className='amenities__item__label'>{e.name}</span>
                  </div>
                );
              })
            : 'No Amenities added'}
        </div>
      )}
      {!isSM && data?.data?.amenities?.length > 4 ? (
        <p className='amenities__toggle' onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? `Show less amenities` : `Show all ${data?.data?.amenities?.length} amenities`}
        </p>
      ) : (
        ''
      )}
      {data?.data?.unitMix?.unitMix?.length ? (
        <>
          <p className='fz-18 mt-40 fw-600'>Unit Mix</p>
          <Table
            className='unit-table'
            dataSource={unitMix}
            columns={unitMixCols}
            pagination={false}
            scroll={{
              x: 400,
            }}
          />
        </>
      ) : (
        ''
      )}
    </div>
  );
};

export default PropertyAbout;
